//
//
//
//
//
//
//
//
//
//

export default {
  name: 'RouterHolder'
};